import React from 'react'


const About = () => {
  return (
    
    <section class="about" id="about">
        <div class="max-width">
            <h2 class="title">About me</h2>
            <div class="about-content">
                <div class="column left">
                <img src="assets/wale.jpg" alt="" className='' />
                </div>
                <div class="column right">
                    <div class="text">I'm Abdulrahman  and I'm a <span class="typing-2"></span>Web Developer</div>
                    <p>The great pleasure introduce my self. 
                      I’m Abdulrahman Olawale Adekeye , I'm from Kwara State, Since 3 years + I’m working as web || App developer 
                      in Company name SystemTechnology and i also worked for AsyncTechnology in Malaysia(Kaula Lumper) but
                      i worked remotely from Nigeria and i also worked at Femtech as an instructor. I have worked on Projects and i have some of the projects below at the projects sections.
                      and apart from that, I have been part of 
                      Web and App development projects, office work and as freelancer. .</p>
                    <a href="#">Download CV</a>
                </div>
            </div>
        </div>
    </section>
  )
}

export default About